import { AllAttributesContextType, ContextProviderName } from "./types";

export const DEFAULT_ATTRIBUTES_CONTEXT: AllAttributesContextType = {
  attributes: {
    [ContextProviderName.Claim]: undefined,
    [ContextProviderName.CustomRecord]: undefined,
    [ContextProviderName.Dealer]: undefined,
    [ContextProviderName.Directive]: undefined,
    [ContextProviderName.Eval]: undefined,
    [ContextProviderName.FailureMode]: undefined,
    [ContextProviderName.FailureModeEvents]: undefined,
    [ContextProviderName.Inspection]: undefined,
    [ContextProviderName.InspectionItem]: undefined,
    [ContextProviderName.Issue]: undefined,
    [ContextProviderName.NotesVerification]: undefined,
    [ContextProviderName.Part]: undefined,
    [ContextProviderName.Labor]: undefined,
    [ContextProviderName.Repair]: undefined,
    [ContextProviderName.RepairPart]: undefined,
    [ContextProviderName.RepairPartVerification]: undefined,
    [ContextProviderName.RepairLaborVerification]: undefined,
    [ContextProviderName.RepairVerification]: undefined,
    [ContextProviderName.RiskModelPrediction]: undefined,
    [ContextProviderName.Run]: undefined,
    [ContextProviderName.Schedule]: undefined,
    [ContextProviderName.SensorReading]: undefined,
    [ContextProviderName.ServiceCenters]: undefined,
    [ContextProviderName.ServiceRecord]: undefined,
    [ContextProviderName.SignalEventOccurrence]: undefined,
    [ContextProviderName.Vehicle]: undefined,
    [ContextProviderName.WorkOrder]: undefined,
    [ContextProviderName.WorkOrderVerification]: undefined,
    [ContextProviderName.RepairLabor]: undefined,
    [ContextProviderName.KnowledgeItem]: undefined,
    [ContextProviderName.KnowledgeSourceDocument]: undefined,
  },
  groupByValues: {
    [ContextProviderName.Claim]: {},
    [ContextProviderName.CustomRecord]: {},
    [ContextProviderName.Dealer]: {},
    [ContextProviderName.Directive]: {},
    [ContextProviderName.Eval]: {},
    [ContextProviderName.FailureMode]: {},
    [ContextProviderName.FailureModeEvents]: {},
    [ContextProviderName.Inspection]: {},
    [ContextProviderName.InspectionItem]: {},
    [ContextProviderName.Issue]: {},
    [ContextProviderName.Repair]: {},
    [ContextProviderName.RepairVerification]: {},
    [ContextProviderName.RepairPart]: {},
    [ContextProviderName.RepairLabor]: {},
    [ContextProviderName.RepairPartVerification]: {},
    [ContextProviderName.RepairLaborVerification]: {},
    [ContextProviderName.RiskModelPrediction]: {},
    [ContextProviderName.Run]: {},
    [ContextProviderName.Schedule]: {},
    [ContextProviderName.SensorReading]: {},
    [ContextProviderName.SignalEventOccurrence]: {},
    [ContextProviderName.Vehicle]: {},
    [ContextProviderName.VehicleECU]: {},
    [ContextProviderName.VehicleOption]: {},
    [ContextProviderName.VehiclePart]: {},
    [ContextProviderName.ServiceCenters]: {},
    [ContextProviderName.WorkOrder]: {},
    [ContextProviderName.WorkOrderVerification]: {},
    [ContextProviderName.WorkOrderParts]: {},
    [ContextProviderName.Part]: {},
    [ContextProviderName.Labor]: {},
    [ContextProviderName.ServiceRecord]: {},
    [ContextProviderName.NotesVerification]: {},
    [ContextProviderName.Asset]: {},
    [ContextProviderName.ManufactureLineExit]: {},
    [ContextProviderName.ServiceCenterV2]: {},
    [ContextProviderName.WorkOrderVerificationV2]: {},
    [ContextProviderName.RepairPartVerificationV2]: {},
    [ContextProviderName.RepairLaborVerificationV2]: {},
    [ContextProviderName.NotesVerificationV2]: {},
    [ContextProviderName.WorkOrderV2]: {},
    [ContextProviderName.WorkOrderPartsV2]: {},
    [ContextProviderName.RepairV2]: {},
    [ContextProviderName.RepairVerificationV2]: {},
    [ContextProviderName.RepairPartV2]: {},
    [ContextProviderName.RepairLaborV2]: {},
    [ContextProviderName.VMRSV2]: {},
    [ContextProviderName.SensorReadingV2]: {},
    [ContextProviderName.KnowledgeItem]: {},
    [ContextProviderName.KnowledgeSourceDocument]: {},
  },
};
